import zhLocale from 'element-ui/lib/locale/lang/zh-TW'
import home from './zh_cht/home'

const cn = {
    language: '繁体中文',
    message: {
        'home': {
            ...home,
            'enterEmail': '請輸入電子郵件',
            'save': '保存',
            'saveSuccess': '保存成功',
            'pointHistory': '積分歷史',
            'type': '類型',
            'remark': '備註',
            'pendingComment': '待評價',
            'commented': '已評價',
            'selectDate': '選擇日期',
            'loginSuccess': '登錄成功',
            'loginFail': '登錄失敗',
            'close': '關閉',
            'required': '必填',
            'nickname': '暱稱',
            'enterNickname': '請輸入暱稱',
            'gender': '性別',
            'male': '男',
            'female': '女',
            'secret': '保密',
            'birthday': '生日',
            checkoutLoadFailed: '結算資訊載入失敗，請稍後重試',
            checkoutErrorTitle: '提示',
            goAddAddress: '去添加收貨地址',
            shop_order_selectOrAddAddress: '請先添加收貨地址，並設為預設地址後再結算',
            shop_order_cartEmpty: '購物車為空，無法結算',
            shop_order_cartHasNotActive: '存在未上架或無效商品，無法結算',
            shop_order_cartHasNotMarketable: '存在已下架商品，無法結算',
            shop_order_cartHasLowStock: '商品庫存不足，無法結算',
            shop_order_cartHasExpiredGoods: '店鋪商品已過期，無法結算',
            shop_order_typeIsNull: '訂單類型無法識別，請檢查商品類型',
            shop_order_goodsNotFound: '商品資訊不存在或已刪除',
            shop_order_giftNotForSale: '贈品不能直接購買結算',
            common_message_badRequest: '請求無效，請檢查商品與參數',
        },
    },
    '手机号码最小长度为8位': "手機號碼最小長度為8位。",
    '邮箱账号名称最小长度为6位': "郵箱賬號名稱最小長度為6位。",
    '邮箱只能包含英文，数字等字符': "郵箱只能包含英文，數字等字符",
    '请选择正确的收货地址': "請選擇正確的收貨地址。",
    Dict_language_status_0: '禁用',
    Dict_language_status_1: '啟用',
    Dict_member_label_type_1: '條件標籤',
    Dict_member_label_type_2: '手動標籤',
    Dict_member_level_type_0: '消費等級（LV）',
    Dict_member_level_type_1: '付費會員（VIP）',
    Dict_member_growth_action_type_1: '消費下單',
    Dict_member_growth_action_type_2: '每日登錄',
    Dict_member_growth_action_type_3: '發佈評價',
    Dict_member_growth_action_type_4: '完善資料',
    Dict_paid_member_payment_type_0: '餘額支付',
    Dict_paid_member_payment_type_1: '微信支付',
    Dict_paid_member_payment_type_2: '支付寶',
    Dict_paid_member_payment_type_3: 'PayPal',
    Dict_paid_member_record_status_0: '有效',
    Dict_paid_member_record_status_1: '已到期',
    Dict_paid_member_record_status_2: '已退款',
    Dict_point_lottery_prize_type_0: '積分',
    Dict_point_lottery_prize_type_1: '優惠券',
    Dict_point_lottery_prize_type_2: '實物獎品',
    Dict_point_lottery_prize_type_3: '謝謝參與',
    Dict_notification_channel_type_0: '簡訊',
    Dict_notification_channel_type_1: '郵件',
    Dict_notification_channel_type_2: '站內信',
    Dict_notification_channel_type_3: 'Push推送',
    Dict_announcement_status_0: '草稿',
    Dict_announcement_status_1: '已發佈',
    Dict_announcement_status_2: '已下架',
    Dict_live_permission_status_0: '未申請',
    Dict_live_permission_status_1: '審核中',
    Dict_live_permission_status_2: '已開通',
    Dict_live_permission_status_3: '已拒絕',
    Dict_live_room_status_0: '未開始',
    Dict_live_room_status_1: '直播中',
    Dict_live_room_status_2: '已結束',
    Dict_live_room_status_3: '異常中斷',
    Dict_live_room_type_0: '平台直播',
    Dict_live_room_type_1: '商戶直播',
    Dict_store_type_0: '個人店',
    Dict_store_type_1: '企業店',
    Dict_store_sign_status_0: '待簽約',
    Dict_store_sign_status_1: '已簽約',
    Dict_store_sign_status_2: '解約',
    Dict_store_business_change_status_0: '待審核',
    Dict_store_business_change_status_1: '審核通過',
    Dict_store_business_change_status_2: '審核拒絕',
    Dict_decoration_page_type_0: '首頁',
    Dict_decoration_page_type_1: '分類頁',
    Dict_decoration_page_type_2: '活動頁',
    Dict_decoration_page_type_3: '自定義頁',
    Dict_decoration_status_0: '草稿',
    Dict_decoration_status_1: '已發佈',
    Dict_decoration_popup_trigger_page_0: '平台首頁',
    Dict_decoration_popup_trigger_page_1: '會員中心',
    Dict_decoration_popup_trigger_page_2: '支付成功',
    Dict_decoration_popup_target_user_0: '所有使用者',
    Dict_decoration_popup_target_user_1: '免費會員',
    Dict_decoration_popup_target_user_2: '付費會員',
    Dict_decoration_popup_frequency_0: '永久一次',
    Dict_decoration_popup_frequency_1: '每次進入',
    Dict_decoration_popup_frequency_2: '自定義頻次',
    Dict_track_event_type_page_view: '頁面訪問',
    Dict_track_event_type_click: '點擊',
    Dict_track_event_type_add_to_cart: '加入購物車',
    Dict_track_event_type_search: '搜尋',
    Dict_track_event_type_purchase: '購買',
    Dict_track_event_type_live_watch: '觀看直播',
    Dict_reconcile_period_type_0: '日',
    Dict_reconcile_period_type_1: '週',
    Dict_reconcile_period_type_2: '月',
    Dict_store_settlement_status_0: '待結算',
    Dict_store_settlement_status_1: '已結算',
    Dict_distributor_status_0: '待審核',
    Dict_distributor_status_1: '已審核',
    Dict_distributor_status_2: '已拒絕',
    Dict_distribution_commission_type_0: '直接佣金',
    Dict_distribution_commission_type_1: '間接佣金',
    Dict_configuration_status_0: '禁用',
    Dict_configuration_status_1: '啟用',
    ...zhLocale
}

export default cn
